var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-row',[_c('b-col',{staticClass:"margin-izquierdo"},[_c('h3',{staticClass:"color-primary"}),_c('br'),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }